import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import useStyles from 'hooks/useStyles';

import styles from './HighlightItem.scss';

const cx = classNames.bind(styles);

function HighlightItem({ className, iconUrl, content }) {
  useStyles(styles);

  return (
    <li className={cx(styles.root, className)}>
      <img src={iconUrl} alt={content} className={styles.icon} />
      <div className={styles.content}> {content}</div>
    </li>
  );
}

HighlightItem.defaultProps = {
  className: '',
};

HighlightItem.propTypes = {
  iconUrl: string.isRequired,
  content: string.isRequired,
  className: string,
};

export default HighlightItem;
